
import { Card } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface StatData {
  label: string;
  value: number;
}

interface ProductSubscriptionsChartProps {
  data: StatData[];
}

export const ProductSubscriptionsChart = ({ data }: ProductSubscriptionsChartProps) => {
  return (
    <div className="h-[300px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="label" angle={-45} textAnchor="end" height={70} />
          <YAxis />
          <Tooltip />
          <Bar dataKey="value" fill="#008169" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
